import Vendor from "./Vendor";
import VendorUnitImage from "./VendorUnitImage";

export default class VendorUnit {
  vendorUnitId!: number;
  vendorId!: number;
  unitName!: string;
  unitDescription!: string;
  vendorUnitImages!: VendorUnitImage[];
  uniqueIdForSelection!: string;
  isLive!: boolean;
  sortOrder!: number;
  personPerUnit!: number;

  sell!: number;
  rates!: any[];
  published!: boolean;

  // unitType!: string;

  public constructor(init?: Partial<VendorUnit>) {
    Object.assign(this, init);
  }
}